import {ActiveUserAction, ActiveUserActionType} from './active-user.action';
import {ActiveUserState, initialActiveUserState} from './active-user.state';

export function activeUserReducer(
  state: ActiveUserState = initialActiveUserState,
  action: ActiveUserAction
): ActiveUserState {
  switch (action.type) {
    case ActiveUserActionType.GET_SUCCESS: {
      const user = action.payload.user
        ? {
            ...action.payload.user,
            // Preserve locally-computed systemCoins when API payload doesn't include it.
            systemCoins: action.payload.user.systemCoins ?? state.user?.systemCoins ?? 0,
          }
        : action.payload.user;

      return {
        ...state,
        user,
        lens: user?.lens ?? null,
        role: user?.roles?.[0] ?? null,
        alertsCount: user?.count ?? 0,
      };
    }
    case ActiveUserActionType.SET_ACTIVE_USER:
      return {...state, user: action.payload.user};
    case ActiveUserActionType.SET_ACTIVE_USER_LENS:
      return {...state, lens: action.payload.lens};
    case ActiveUserActionType.SET_ACTIVE_USER_ROLE:
      return {...state, role: action.payload.role};
    case ActiveUserActionType.CLEAR:
      return {
        user: null,
        lens: null,
        role: null,
        alertsCount: 0,
      };
    default:
      return state;
  }
}
